import * as tslib_1 from "tslib";
import { Row } from '@h3/antd-vue';
import { Component, Prop, Vue } from "vue-property-decorator";
let FormRow = class FormRow extends Vue {
};
tslib_1.__decorate([
    Prop()
], FormRow.prototype, "control", void 0);
FormRow = tslib_1.__decorate([
    Component({
        name: 'form-row',
        components: {
            ARow: Row
        }
    })
], FormRow);
export default FormRow;
